const displayTypes = {
  none: 'none',
  flex: 'flex',
  block: 'block',
  flexEnd: 'inline-block',
};

const defaultFlex = {
  flexStart: 'flex-start',
  center: 'center',
  flexEnd: 'flex-end',
};

const alignTypes = {
  ...defaultFlex,
  stretch: 'stretch',
  baseline: 'baseline',
};
const justifyTypes = {
  ...defaultFlex,
  spaceBetween: 'space-between',
  spaceAround: 'space-around',
  spaceEvenly: 'space-evenly',
};

export {
  displayTypes,
  defaultFlex,
  alignTypes,
  justifyTypes,
};
